export default __webpack_public_path__ + "static/media/NetworkDevicesImg.c87fab02.jpg";